export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_K_AUDIENCES_SESSIONS_CHARTS_DATA = "GET_K_AUDIENCES_SESSIONS_CHARTS_DATA";
export const GET_K_STORE_VISITS_DATA = "GET_K_STORE_VISITS_DATA";
export const GET_USER_GROWTH_DATA = "GET_USER_GROWTH_DATA";

console.log("Action type constants:", {
    API_RESPONSE_SUCCESS,
    GET_K_AUDIENCES_SESSIONS_CHARTS_DATA,
    GET_K_STORE_VISITS_DATA,
    GET_USER_GROWTH_DATA
}); 